<template>
  <div :class="['row']">
    <div class="col-2 offset-md-4 col-md-1 column table-cell--custom">
      <img :src="team.logo" class="team-logo" />
    </div>
    <div class="col-8 col-md-2 column table-cell--custom">
      <div class="col-12 table-cell--custom text-primary--custom">
        {{ teamName }}
      </div>
    </div>
    <div class="col-2 col-md-1 column table-cell--custom">
      <div class="col-12 table-cell--custom  text-primary--custom">
        {{ team.roundScore.toFixed(2) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from "vue";
import Team from '@/shared/teams/team';

export default {
  name: "EliminatedTeamItem",
  props: {
    team: {
      type: Object as PropType<Team>,
    }
  },
  setup(props: any) {
    let teamName = props.team.name + ' ';

    if (teamName.length > 23 && screen.width < process.env.VUE_APP_WIDTH_PHONE_PORTRAIT) {
      teamName = teamName.substring(0,20) + '...';
    }

    return { teamName };
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
.team-logo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #f8f6e4;
  float: left;
}

.team--danger {
  opacity: 0.6;
}

.team--out {
  opacity: 0.3
}

.row {
  margin-bottom: 15px;
}

@media screen and (max-width: $width-small) {
  .table-cell--custom {
    position: relative;
    text-align: left;
    padding: 0 !important;
  }

  .text-primary--custom {
    font-weight: bold;
  }

  .text-secondary--custom {
    font-size: 11px;
    color: $color-secondary-text;
  }
}
</style>